import { precookFunction } from "@next-core/cook";
export function traverseStoryboardFunctions(functions, beforeVisitGlobal, options) {
  if (Array.isArray(functions)) {
    for (const fn of functions) {
      if (!(options !== null && options !== void 0 && options.matchSource) || options.matchSource(fn.source)) {
        traverseStoryboardFunction(fn, beforeVisitGlobal);
      }
    }
  }
}
export function traverseStoryboardFunction(fn, beforeVisitGlobal, silentErrors) {
  try {
    precookFunction(fn.source, {
      typescript: fn.typescript,
      withParent: true,
      hooks: {
        beforeVisitGlobal
      },
      cacheKey: fn
    });
  } catch (error) {
    if (!silentErrors) {
      // eslint-disable-next-line no-console
      console.error(`Parse storyboard function "${fn.name}" failed:`, error);
    }
  }
}
//# sourceMappingURL=traverse.js.map